import classNames from 'classnames'
import { useCallback, useMemo, useState } from 'react'

import styles from './Icon.module.scss'

interface IIcon {
  className: string
  group: string
  iconId: string
  show: boolean
  onClick?: (icon: string) => void
  overlayVisible?: boolean
}

export const Icon = ({ className, group, iconId, show, onClick, overlayVisible = true }: IIcon) => {
  const [copied, setCopied] = useState<boolean>(false)
  const calcGroup = useCallback((group: string) => {
    if (group === 'HPIcon') {
      return 'hpicon'
    }
    return 'kbase'
  }, [])
  const font = useMemo(() => {
    return calcGroup(group)
  }, [calcGroup, group])

  const defaultClickHandler = () => {
    navigator.clipboard.writeText(`${font} ${iconId}`)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <div
      data-testid={`icons__${iconId}`}
      className={classNames(styles.item, className, show ? '' : styles['item--hidden'])}
      tabIndex={0}
      onClick={() => {
        if (onClick) {
          return onClick(`${font} ${iconId}`)
        }
        return defaultClickHandler()
      }}
    >
      <i className={classNames(styles.item__icon, `${font} ${iconId}`)} />
      <p className={styles.item__code}>{iconId}</p>
      {overlayVisible ? (
        <div className={styles.item__overlay}>{copied ? 'Copied!' : 'Copy'}</div>
      ) : null}
    </div>
  )
}
